<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
window.addEventListener(
  "message",
  function (event) {
    const { type, res } = event.data;
    if (type === "renderQrCode") {
      window.$sk.template.skQrCodeRender(res);
    }
  },
  false
);
</script>
<style></style>
